import {createSelector} from 'reselect';
import {isLoadingIvsVin} from "./ivsCallCenterResults";
import {isLoadingLeasingCompanies} from "./leasingCompanies";
import {isLoadingVehicleProperties} from "./vehicleProperties";
import {isLoadingDealers} from "./dealers";

export const isLoading = createSelector(isLoadingDealers, isLoadingIvsVin, isLoadingLeasingCompanies, isLoadingVehicleProperties, (...args) => args.some(Boolean));



// WEBPACK FOOTER //
// ./src/selectors/appointmentCreationModal.js